"use client";
import { isTvEnv } from "@/utils/common.helpers";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { Loader } from "./Loader";

export default function NavigationLoader() {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  const originalPush = useRef<typeof router.push | undefined>(undefined);
  const originalReplace = useRef<typeof router.replace | undefined>(undefined);
  const originalBack = useRef<typeof router.back | undefined>(undefined);
  const originalForward = useRef<typeof router.forward | undefined>(undefined);

  const pathname = usePathname();
  // Track navigation completion via route changes
  useEffect(() => {
    setIsLoading(false);
  }, [pathname]);

  // Patch the router methods to use startTransition
  useEffect(() => {
    if (!isTvEnv()) {
      return;
    }
    // Store original methods
    if (!originalPush.current) {
      originalPush.current = router.push;
      originalReplace.current = router.replace;
      originalBack.current = router.back;
      originalForward.current = router.forward;
    }

    // Override router methods to show loading state during navigation
    if (router && typeof router === "object") {
      router.push = (href, options) => {
        if (href !== pathname) {
          setIsLoading(true);
        }
        originalPush.current?.(href, options);
      };

      router.replace = (href, options) => {
        if (href !== pathname) {
          setIsLoading(true);
        }
        originalReplace.current?.(href, options);
      };

      router.back = () => {
        setIsLoading(true);
        originalBack.current?.();
      };

      router.forward = () => {
        originalForward.current?.();
      };
    }

    // will trigger the loader when user presses back button on tv remote
    window.startNavigationLoader = () => {
      setIsLoading(true);
    };

    window.stopNavigationLoader = () => {
      setIsLoading(false);
    };
  }, [router, pathname]);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="fixed left-0 right-0 top-0 z-50 h-full w-full bg-black/50">
      <Loader />
    </div>
  );
}
